// 首页模块
import request from '@/utils/request'

// 加载专家主页所有数据
export const getMavinHomePage = (params) => {
  return request({
    method: 'get',
    url: '/mavin/mavinHomePage',
    params: params
  })
}

// 切换彩种接口
export const changeLottery = (params) => {
  return request({
    method: 'get',
    url: '/mavin/mavinHomePageChangeLottery',
    params: params
  })
}

// 切换期数接口
export const changeDays = (params) => {
  return request({
    method: 'get',
    url: '/mavin/mavinHomePageChangeDays',
    params: params
  })
}

// 切换玩法
export const changePlaytype = (params) => {
  return request({
    method: 'get',
    url: '/mavin/mavinHomePageChangePlaytype',
    params: params
  })
}

// 上拉加载帖子列表数据
export const morePost = (params) => {
  return request({
    method: 'get',
    url: '/mavin/morePost',
    params: params
  })
}